import React from "react";

function LeftCard({ image, header, description, description01 = null , description02 = null,description03 = null,description04 = null,description05 = null}) {
  return (
    <div className="left-card">
      <div className="left-card-image">
        <img src={image} alt={header} />
      </div>
      <div className="left-card-desc">
        <h2>{header}</h2>
        <p>{description}</p>
        {description01 && <p>{description01}</p>}
        {description02 && <p>{description02}</p>}
        {description03 && <p>{description03}</p>}
        {description04 && <p>{description04}</p>}
        {description05 && <p>{description05}</p>}
      </div>
    </div>
  );
}

export default LeftCard;
